import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Closet = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M21.101 16.383L13 10.491v-.618A4.005 4.005 0 0 0 16 6c0-2.206-1.794-4-4-4S8 3.794 8 6h2c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2a1 1 0 0 0-1 1v1.491l-8.101 5.892a1.969 1.969 0 0 0-.726 2.235A1.97 1.97 0 0 0 4.075 20h15.85a1.97 1.97 0 0 0 1.902-1.382 1.97 1.97 0 0 0-.726-2.235zM19.925 18H4.075L12 12.236l7.937 5.763a.036.036 0 0 1-.012.001z", key: "k0" })));
});
Closet.displayName = 'Closet';
export var ClosetDimensions = { height: 24, width: 24 };
